"use strict";
'use client';

var _objectSpread = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LinkFloatingToolbar = LinkFloatingToolbar;
var _react = _interopRequireDefault(require("react"));
var _cn = require("@udecode/cn");
var _plateCommon = require("@udecode/plate-common");
var _index = require("../forks/floating/index");
var _plateLink = require("@udecode/plate-link");
var _button = require("./button");
var _input = require("./input");
var _popover = require("./popover");
var _separator = require("./separator");
var _ri = require("react-icons/ri");
var _useFloatingLinkInsert = require("../hooks/useFloatingLinkInsert");
var _useFloatingLinkEdit = require("../hooks/useFloatingLinkEdit");
var _linkOpenButton = require("./link-open-button");
var _jsxRuntime = require("react/jsx-runtime");
var floatingOptions = {
  middleware: [(0, _index.offset)(12), (0, _index.flip)({
    fallbackPlacements: ['bottom-end', 'top-start', 'top-end'],
    padding: 12
  })],
  placement: 'bottom-start'
};
function LinkFloatingToolbar(_ref) {
  var state = _ref.state;
  var insertState = (0, _useFloatingLinkInsert.useFloatingLinkInsertState)(_objectSpread({}, state, {
    floatingOptions: _objectSpread({}, floatingOptions, state === null || state === void 0 ? void 0 : state.floatingOptions)
  }));
  var _ref2 = (0, _useFloatingLinkInsert.useFloatingLinkInsert)(insertState),
    hidden = _ref2.hidden,
    insertProps = _ref2.props,
    insertRef = _ref2.ref,
    textInputProps = _ref2.textInputProps;
  var editState = (0, _useFloatingLinkEdit.useFloatingLinkEditState)(_objectSpread({}, state, {
    floatingOptions: _objectSpread({}, floatingOptions, state === null || state === void 0 ? void 0 : state.floatingOptions)
  }));
  var _ref3 = (0, _useFloatingLinkEdit.useFloatingLinkEdit)(editState),
    editButtonProps = _ref3.editButtonProps,
    editProps = _ref3.props,
    editRef = _ref3.ref,
    unlinkButtonProps = _ref3.unlinkButtonProps;
  var inputProps = (0, _plateCommon.useFormInputProps)({
    preventDefaultOnEnterKeydown: true
  });
  if (hidden) return null;
  var input = /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", _objectSpread({
    className: "flex w-[330px] flex-col"
  }, inputProps, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "flex items-center",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "flex items-center pl-3 text-muted-foreground",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ri.RiLink, {
          className: "size-4"
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_plateLink.FloatingLinkUrlInput, {
        className: (0, _input.inputVariants)({
          h: 'sm',
          variant: 'ghost'
        }),
        placeholder: "Paste link"
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_separator.Separator, {}), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "flex items-center",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "flex items-center pl-3 text-muted-foreground",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ri.RiText, {
          className: "size-4"
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("input", _objectSpread({
        className: (0, _input.inputVariants)({
          h: 'sm',
          variant: 'ghost'
        }),
        placeholder: "Text to display"
      }, textInputProps))]
    })]
  }));
  var editContent = editState.isEditing ? input : /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "box-content flex h-9 items-center gap-1",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("button", _objectSpread({
      className: (0, _button.buttonVariants)({
        size: 'sm',
        variant: 'ghost'
      }),
      type: "button"
    }, editButtonProps, {
      children: "Edit link"
    })), /*#__PURE__*/(0, _jsxRuntime.jsx)(_separator.Separator, {
      orientation: "vertical"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_linkOpenButton.LinkOpenButton, {
      className: (0, _button.buttonVariants)({
        size: 'sms',
        variant: 'ghost'
      }),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ri.RiExternalLinkLine, {
        width: 18
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_separator.Separator, {
      orientation: "vertical"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("button", _objectSpread({
      className: (0, _button.buttonVariants)({
        size: 'sms',
        variant: 'ghost'
      }),
      type: "button"
    }, unlinkButtonProps, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ri.RiLinkUnlink, {
        width: 18
      })
    }))]
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", _objectSpread({
      className: (0, _cn.cn)((0, _popover.popoverVariants)(), 'w-auto p-1'),
      ref: insertRef
    }, insertProps, {
      children: input
    })), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", _objectSpread({
      className: (0, _cn.cn)((0, _popover.popoverVariants)(), 'w-auto p-1'),
      ref: editRef
    }, editProps, {
      children: editContent
    }))]
  });
}